export default __webpack_public_path__ + "static/media/Alarm Message.890b6663.png";